/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  fill?: string,
}>;

const PlayIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 18 22"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={props.fill || "none"} strokeLinecap="round" strokeLinejoin="round">
      <polygon points="0.354166667 0.416666667 16.6458333 10 0.354166667 19.5833333" />
    </g>
  </svg>
);

export default PlayIcon;
